import React from "react";
import css from "./spinner.module.css";

export const Spinner = () => {
  return <div className={css.Loader}></div>;
};
